<section class="popular-vechicle-sec pt-5 pb-5">
    <div class="container">
        <div class="content-heading mb-4" *ngIf="popularVehicleList?.length>0">
            <h1 class="page-sub-title cv-text-dark">Trending Products</h1>
        </div>
        <div class="carousel-sec">
            <ng-container *ngIf="popularVehicleList?.length == 0 && !productLoaded;else productTemplate">
                <owl-carousel-o [options]="customOptions1">
                    <ng-template carouselSlide *ngFor="let item of skeletonService.generateFake(6);let i = index;">

                        <div class="item">
                            <div class="card h-100">
                                <div class="card-body">
                                    <div class="d-flex align-items-center mb-4 launch-div">
                                        <span class="badge bg-primary">
                                            <ngx-skeleton></ngx-skeleton>
                                        </span>
                                        <div class="like ms-auto">
                                            <ngx-skeleton></ngx-skeleton>
                                        </div>
                                    </div>
                                    <div class="item-img">
                                        <ngx-skeleton></ngx-skeleton>
                                    </div>
                                    <div class="content mt-4">
                                        <ngx-skeleton height="20px"></ngx-skeleton>
                                        <div class="price d-flex align-items-center">
                                            <ngx-skeleton height="20px"></ngx-skeleton>
                                        </div>
                                        <div class="rating">
                                            <ngx-skeleton height="50px"></ngx-skeleton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </ng-container>

            <ng-template #productTemplate>
                <owl-carousel-o [options]="customOptions1">
                    <ng-template carouselSlide *ngFor="let row of popularVehicleList">
                        <div class="item">
                            <div class="card h-100">
                                <div class="card-body">
                                    <div class="d-flex align-items-center mb-4 launch-div">
                                        <span class="badge bg-primary" *ngIf="row.is_new_launch">
                                            Trending Products
                                        </span>
                                        <div class="like ms-auto">

                                            <button
                                                style="width: 24px; height: 24px; border: none;background-color: transparent;"
                                                (click)="clickToAddWishlist(row.id)">
                                                <span *ngIf="!row.wishlist">
                                                    <img [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                                                </span>
                                                <span *ngIf="row.wishlist">
                                                    <img [src]="environment1 + 'images/new-images/fillHeart.svg'" alt="fillHeart" loading="lazy">
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="item-img">
                                        <div class="img-wrapper">
                                            <a [routerLink]="openProduct(row)">
                                                <img *ngIf="row?.images[0]?.image_url" alt="popular_vehicle"
                                                    src="{{row?.images[0]?.image_url}}" style="cursor: pointer;"
                                                    class="img-fluid" loading="lazy" />
                                            </a>


                                        </div>
                                        <div class="img-slide-wrapper">
                                            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel"
                                                [config]="slideConfig">
                                                <div ngxSlickItem *ngFor="let slide of row.imgData" class="slide">
                                                    <div class="slick-custom-height">
                                                        <a [routerLink]="openProduct(row)">
                                                            <img style="cursor: pointer;" src="{{ slide.image_url }}"
                                                                loading="lazy" alt="popular_vehicle">
                                                        </a>
                                                    </div>
                                                </div>
                                            </ngx-slick-carousel>
                                        </div>
                                    </div>
                                    <div class="content mt-2" style="height: 100px;">
                                        <a [routerLink]="openProduct(row)">
                                            <h6 class="fw-bold cursor text-ellipsis">{{row.model}}</h6>
                                        </a>
                                        <div class="price d-flex align-items-center">
                                            <h5 class="mb-0">{{row.price_range| currency:'INR':'symbol':'4.0-0'}}</h5>
                                            <span class="ms-2">Ex-showroom </span>
                                        </div>
                                        <div class="rating">
                                                <ngx-stars [readonly]="true" [customStarIcons]="heartUrls"
                                                    [color]="'#FDC602'" [initialStars]="row.rating" [size]="5"></ngx-stars>
                                        </div>
                                    </div>
                                    <div class="card-footer" style="border-top: none; background-color: transparent;">
                                        <div class="book-now">
                                            <button type="button"
                                                class="btn btn-primary text-book-now btn-lg btn-grad-primary btn-brand w-100"
                                                data-toggle="tooltip" data-placement="top" title="Click here for Booking"
                                                (click)="bookNow(row)">Book Now at {{row.down_payment |
                                                currency:'INR':'symbol':'4.0-0'}}</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </ng-template>


        </div>
    </div>


</section>
